import CloseIcon from "@mui/icons-material/Close";
import { Box, Dialog, IconButton, Stack, Typography } from "@mui/material";

import ProveedoresPage from "../pages/ProveedoresPage";

export default function SuppliersManagerModal({ open, onClose }) {
  return (
    <Dialog
      open={Boolean(open)}
      onClose={onClose}
      maxWidth={false}
      PaperProps={{
        sx: {
          width: "min(96vw, 1180px)",
          height: "min(92vh, 760px)",
          p: 2.5,
          borderRadius: "30px",
          bgcolor: "neutral.300",
          overflow: "hidden",
        },
      }}
    >
      <Stack spacing={1.5} sx={{ height: "100%", minHeight: 0 }}>
        <Stack direction="row" sx={{ alignItems: "center", justifyContent: "space-between" }}>
          <Box>
            <Typography sx={{ color: "primary.900", fontSize: 21, fontWeight: 900 }}>
              Gestionar proveedores
            </Typography>
            <Typography sx={{ color: "neutral.700", fontSize: 12.5, fontWeight: 600 }}>
              Consultá, agregá o editá los proveedores de las presentaciones de compra.
            </Typography>
          </Box>
          <IconButton aria-label="Cerrar gestión de proveedores" onClick={onClose}>
            <CloseIcon sx={{ color: "primary.900" }} />
          </IconButton>
        </Stack>
        <Box sx={{ minHeight: 0, flex: 1, display: "flex", flexDirection: "column" }}>
          <ProveedoresPage embedded />
        </Box>
      </Stack>
    </Dialog>
  );
}
